import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";

interface useDeleteTaxSubmissionProps {
    taxSubmissionId: string;
}

export const useDeleteTaxSubmission = () => {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (query: useDeleteTaxSubmissionProps) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${query.taxSubmissionId}`,
                {
                    headers,
                    method: "DELETE",
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissions"],
            });
            queryClient.invalidateQueries({ queryKey: ["useGetKPIs"] });
        },
        meta: {
            errorMessage: t("errors.messages.deleteTaxSubmission"),
        },
    });

    return mutation;
};
